"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=department.dto.js.map